import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-payment-methods',
    templateUrl: './payment-methods.component.html',
})
export class PaymentMethodsComponent implements OnInit {
    constructor() {}

    @Output() onReady: EventEmitter<void> = new EventEmitter();
    @Output() onBack: EventEmitter<void> = new EventEmitter();

    @Input() totalPayment = 0.0;

    selectedMethod: any = {};
    accept = false;

    methodList: any = [
        {
            id: 'visa',
            icon: 'assets/img/inter/icon/visa.png',
            message: 'Tarjetas asociadas a VISANET',
        },
    ];

    ngOnInit() {
        this.selectedMethod = this.methodList[0];
    }
}
